import React, { useState, useEffect } from "react";
import { GetData, PostData } from "../../../services/api";
import DataTable from "react-data-table-component";
import {
  Container,
  Row,
  Col,
  Button,
  Badge
} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import Loader from "../../../components/Common/Loader";
import Swal from 'sweetalert2';
import moment from "moment";

const Executions = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    workflowId: "",
    status: "",
  });

  useEffect(() => {
    fetchData();
  }, [filters]);

  const fetchData = async () => {
    try {
      const params = new URLSearchParams();
      if (filters.workflowId) params.append("workflowId", filters.workflowId);
      if (filters.status) params.append("status", filters.status);
      
      const { data } = await GetData(`/workflow-executions?${params.toString()}`);
      setData(data);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching executions:", err);
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      running: { color: "info", text: "Ejecutando" },
      completed: { color: "success", text: "Completado" },
      paused: { color: "warning", text: "Pausado" },
      failed: { color: "danger", text: "Fallido" },
    };
    const statusInfo = statusMap[status] || { color: "secondary", text: status };
    return <Badge color={statusInfo.color}>{statusInfo.text}</Badge>;
  };

  const handleRetry = async (id) => {
    try {
      await PostData(`/workflow-executions/${id}/retry`, {});
      Swal.fire("Ejecución reiniciada", "", "success");
      fetchData();
    } catch (err) {
      Swal.fire("Error", err.message, "error");
    }
  };

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Flujo</span>,
      selector: (row) => row.workflowId,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Contacto</span>,
      selector: (row) => row.contactId,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Estado</span>,
      cell: (row) => getStatusBadge(row.status),
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Pasos Ejecutados</span>,
      selector: (row) => row.stepHistory?.length || 0,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Iniciado</span>,
      selector: (row) => moment(row.createdAt).format("DD/MM/YYYY HH:mm"),
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Acción</span>,
      cell: (row) => (
        row.status === 'failed' && (
          <Button size="sm" color="warning" onClick={() => handleRetry(row.id)}>
            Reintentar
          </Button>
        )
      ),
    },
  ];

  return (
    <div className="page-content">
      <Container fluid={true}>
        <Breadcrumbs title="IHubG" breadcrumbItem="Ejecuciones de Flujos" />
        <Row className="my-4">
          <Col md={4}>
            <select
              className="form-select"
              value={filters.status}
              onChange={(e) => setFilters({...filters, status: e.target.value})}
            >
              <option value="">Todos los estados</option>
              <option value="running">Ejecutando</option>
              <option value="completed">Completado</option>
              <option value="failed">Fallido</option>
            </select>
          </Col>
        </Row>
        <Row>
          {loading ? (
            <Loader size={150} />
          ) : (
            <DataTable
              data={data}
              columns={columns}
              noDataComponent={<span className="py-4">Sin ejecuciones</span>}
            />
          )}
        </Row>
      </Container>
    </div>
  );
};

export default Executions;

